var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g({class:[`icon-${_vm.name}`, `text-${_vm.variant}`],style:(`font-size: ${_vm.size}rem`)},_vm.$listeners),[(_vm.pathCount > 1)?_vm._l((_vm.pathCount),function(index){return _c('span',{class:`path${index}`})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }